import moment from "moment";

export const checkAvailability = (pass) => {
  const atSupplyLimit =
    pass.supply_limit !== null && pass.supply_limit <= pass.stats["issued"];
  const expiredDate =
    pass.end_date !== null && moment(pass.end_date) < moment(Date.now());
  return !pass.active_state || atSupplyLimit || expiredDate;
};
